import StakeholderPage from 'components/Dashboard/StakeHolders/StakeholderPage';
import React from 'react';
import InfluenceContentContainer from 'components/Dashboard/UserContent/InfluenceContentContainer';
import ContentControl from 'components/Dashboard/ContentControl';
import ParliamentLiveEventView from 'components/Dashboard/ParliamentLive/ParliamentLiveEventView';

// Static, no dependency on props/state - built once at module load instead of on every
// ContentApp render (this was showing up as real, repeated self-time in the profiler).
const ContentMainRoutesMapping = {
  'key-updates': {
    element: <ContentControl />,
  },
  consultations: {
    element: <ContentControl />,
  },
  legislation: {
    element: <ContentControl />,
    parameters: ['type', 'id', 'title'],
  },
  'parliamentary-record': {
    element: <ContentControl />,
    parameters: ['type', 'id', 'title'],
  },
  'committee-publication': {
    element: <ContentControl />,
    parameters: ['id', 'type', 'title'],
  },
  'library-material': {
    element: <ContentControl />,
  },
  stakeholders: {
    element: <StakeholderPage />,
    parameters: ['id', 'name', 'contentType'],
  },
  'policy-asks': {
    element: <InfluenceContentContainer page={'policy-asks'} />,
    shareable: true,
  },
  'briefing-material': {
    element: <InfluenceContentContainer page={'briefing-material'} />,
    shareable: true,
  },
  'news-release': {
    element: <InfluenceContentContainer page={'news-release'} />,
    shareable: true,
  },
  research: {
    element: <InfluenceContentContainer page={'research'} />,
    shareable: true,
  },
  'parliament-live': {
    element: <ParliamentLiveEventView />,
    parameters: ['event'],
  },
  'regulation-docket': {
    element: <ContentControl />,
  },
  'regulation-document': {
    element: <ContentControl />,
  },
  'regulation-comment': {
    element: <ContentControl />,
  },
};

const useContentMainRoutesMapping = () => {
  return { ContentMainRoutesMapping };
};

export default useContentMainRoutesMapping;
